import React, { useState, useEffect } from 'react';
import './Testimonials.css';
import testimonial1 from '../assets/lalit.jpg'; 
import testimonial2 from '../assets/Asad Haque.jpg';
import testimonial3 from '../assets/Tim Best.jpg'; 

const testimonialsData = [
  {
    id: 1,
    name: "Lalit Yagnik",
    title: "CEO of Company",
    image: testimonial1,
    quote: "I've always been concerned about my personal data being leaked online. This extension gives me peace of mind by monitoring everything in real time and alerting me whenever sensitive data is at risk. It’s simple to use, and I love how seamless the integration is with my daily online activities. I can’t imagine browsing without it now!",
  },
  {
    id: 2,
    name: "Asad Haque",
    title: "Marketing Head",
    image: testimonial2,
    quote:  "The dashboard feature is fantastic! I can review all the alerts I've received and get a better understanding of how often my sensitive information is being exposed. It's a great tool for anyone who wants more control over their privacy while browsing the web.",
  },
  {
    id: 3,
    name: "Tim Best",
    title: "Product Manager",
    image: testimonial3,
    quote: "I love that I can customize the alerts and settings based on my preferences. It’s not just a one-size-fits-all solution—it's tailored to my specific needs. I’ve recommended this extension to all my coworkers, and we all feel more secure online.",
  },
];

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    company: '',
    phone: '',
    email: '',
    message: ''
  });
  const [submissionStatus, setSubmissionStatus] = useState(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonialsData.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const handleIndicatorClick = (index) => {
    setCurrentIndex(index);
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setSubmissionStatus('Submitting...');
  
    // Simulating a successful form submission
    setTimeout(() => {
      setSubmissionStatus('Form submitted successfully!');
      
      // Clear form fields after a delay (e.g., 2 seconds)
      setTimeout(() => {
        setSubmissionStatus('');
        setFormData({
          firstName: '',
          lastName: '',
          company: '',
          phone: '',
          email: '',
          message: ''
        });
      }, 2000);
    }, 1000);
  };
  
  // const handleFormSubmit = async (e) => {
  //   e.preventDefault();
  //   setSubmissionStatus('Submitting...');
  //   try {
  //     const response = await fetch(' http://127.0.0.1:5000/request-demo', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify(formData),
  //     });

  //     if (response.ok) {
  //       setSubmissionStatus('Form submitted successfully!');
  //       setFormData({
  //         firstName: '',
  //         lastName: '',
  //         company: '',
  //         phone: '',
  //         email: '',
  //         message: ''
  //       });
  //     } else {
  //       setSubmissionStatus('Form submission failed. Please try again.');
  //     }
  //   } catch (error) {
  //     console.error('Error submitting form:', error);
  //     setSubmissionStatus('Form submission failed due to network error.');
  //   }
  // };

  return (
    <div className="testimonial-section" id="testimonials">
      {/* Testimonials Section */}
      <div className="testimonial-slider">
        <h2 className="section-title">What Our Clients Say</h2>
        <div className="testimonial-card">
          <img
            src={testimonialsData[currentIndex].image}
            alt={testimonialsData[currentIndex].name}
            className="testimonial-image"
          />
          <p className="testimonial-quote">
            "{testimonialsData[currentIndex].quote}"
          </p>
          <div className="testimonial-author">
            <h3>{testimonialsData[currentIndex].name}</h3>
            <h4>{testimonialsData[currentIndex].title}</h4>
          </div>
        </div>
        <div className="testimonial-indicators">
          {testimonialsData.map((_, index) => (
            <span
              key={index}
              className={`indicator-dot ${currentIndex === index ? 'active' : ''}`}
              onClick={() => handleIndicatorClick(index)}
            ></span>
          ))}
        </div>
      </div>

        {/* Form Section */}
        <div className="demo-form-container">
          <h2 className="section-title">Schedule a Demo</h2>
          <form className="demo-form" onSubmit={handleFormSubmit}>
            <input
              type="text"
              name="firstName"
              placeholder="First Name"
              value={formData.firstName}
              onChange={handleInputChange}
              required
            />
            <input
              type="text"
              name="lastName"
              placeholder="Last Name"
              value={formData.lastName}
              onChange={handleInputChange}
              required
            />
            <input
              type="text"
              name="company"
              placeholder="Company"
              value={formData.company}
              onChange={handleInputChange}
              required
            />
            <input
              type="tel"
              name="phone"
              placeholder="Phone"
              value={formData.phone}
              onChange={handleInputChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleInputChange}
              required
            />
            <textarea
              name="message"
              placeholder="How did you hear about us?"
              rows="3"
              value={formData.message}
              onChange={handleInputChange}
            ></textarea>
            <button type="submit" className="submit-button">
              SCHEDULE A DEMO
            </button>
          </form>
          {submissionStatus && <p className="submission-status">{submissionStatus}</p>}
        </div>
      </div>
    );
  };

export default Testimonials;
